<template>
  <div v-if="errormsg">{{ errormsg }}</div>
</template>

<script>
import math from '../mixins/math'
export default {
  name: 'XMLDescription',
  mixins: [math],
  data() {
    return {
      errormsg: null,
    }
  },
  computed: {
    xmlName() {
      return this.$route.params.xmlName
    },
  },
  created() {
    this.download()
  },
  methods: {
    download() {
      if (this.xmlName && this.xmlName.length > 0) {
        this.$axios
          .get(`xmldescription/${this.xmlName}`, {
            responseType: 'arraybuffer',
          })
          .then(res => {
            this.openFile(res.data)
          })
          .catch(err => {
            const errData = JSON.parse(
              Buffer.from(err.response.data).toString('utf8')
            )
            this.errormsg = errData.message
          })
      }
    },
    openFile(fileData) {
      var fileURL = window.URL.createObjectURL(new Blob([fileData]))
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute(
        'download',
        this.safeFileName(this.xmlName) + '.pdf'
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
  },
}
</script>
